import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Design 6: Kırmızı Gradient — Blurlu Geometrik Şekiller
// Dikey koyu kırmızı → siyah gradient. Üstte üçgen, altta yarım daireler.
export const Design6 = ({
  formData,
  setFormData,
  handleSubmit,
  loading,
  error,
  isLogin,
  setIsLogin,
  showPassword,
  setShowPassword,
  broker,
}) => (
  <div
    className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
    style={{
      background:
        'linear-gradient(180deg, #7a0d10 0%, #4a0508 45%, #200205 80%, #0a0203 100%)',
    }}
    data-testid="login-design6-root"
  >
    {/* Kırmızı Gradient Arka Plan — Soyut Geometrik Şekiller (blurred) */}
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Üstteki üçgen — koyu kırmızı, hafif blur */}
      <div
        className="absolute"
        style={{
          top: '-4%',
          left: '48%',
          width: '180px',
          height: '180px',
          transform: 'translateX(-50%) rotate(180deg)',
          background: '#6a0810',
          clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
          filter: 'blur(24px)',
          opacity: 0.85,
        }}
      />
      {/* İkincil daha küçük üçgen */}
      <div
        className="absolute"
        style={{
          top: '2%',
          left: '55%',
          width: '100px',
          height: '100px',
          transform: 'translateX(-50%) rotate(200deg)',
          background: '#7a0d10',
          clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
          filter: 'blur(30px)',
          opacity: 0.6,
        }}
      />
      {/* Sol alt yarım daire */}
      <div
        className="absolute"
        style={{
          bottom: '8%',
          left: '-40px',
          width: '200px',
          height: '200px',
          background: '#2a0306',
          borderRadius: '50%',
          filter: 'blur(28px)',
          opacity: 0.9,
        }}
      />
      {/* Sağ alt yarım daire */}
      <div
        className="absolute"
        style={{
          bottom: '6%',
          right: '3%',
          width: '240px',
          height: '240px',
          background: '#1a0203',
          borderRadius: '50%',
          filter: 'blur(32px)',
          opacity: 0.85,
        }}
      />
      {/* Sol alt L-shape (dikdörtgen blok) */}
      <div
        className="absolute"
        style={{
          bottom: '0%',
          left: '10%',
          width: '140px',
          height: '80px',
          background: '#3a0508',
          filter: 'blur(22px)',
          opacity: 0.7,
        }}
      />
      {/* Sağ orta yumuşak ışık — kırmızı vurgu */}
      <div
        className="absolute"
        style={{
          top: '32%',
          right: '12%',
          width: '280px',
          height: '280px',
          background:
            'radial-gradient(circle, rgba(160, 20, 25, 0.35) 0%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />
      {/* Sol orta yumuşak ışık */}
      <div
        className="absolute"
        style={{
          top: '22%',
          left: '4%',
          width: '220px',
          height: '220px',
          background:
            'radial-gradient(circle, rgba(120, 15, 20, 0.3) 0%, transparent 70%)',
          filter: 'blur(50px)',
        }}
      />
      {/* Alt bant gölgesi */}
      <div
        className="absolute bottom-0 left-0 right-0"
        style={{
          height: '28%',
          background:
            'linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.7) 100%)',
        }}
      />
    </div>

    {/* Login Kartı */}
    <div
      className="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl w-full max-w-md p-8 relative z-10 border border-white/20"
      data-testid="login-design6-card"
    >
      <div className="text-center mb-8">
        <div className="mb-4 flex justify-center">
          {broker && broker.logo_url ? (
            <img
              src={broker.logo_url}
              alt={broker.name}
              className="h-16 w-auto object-contain"
            />
          ) : (
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg"
              style={{ background: 'linear-gradient(135deg, #7a0d10 0%, #2a0306 100%)' }}>
              <svg
                className="w-7 h-7 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                />
              </svg>
            </div>
          )}
        </div>
        <h1 className="text-3xl font-bold text-slate-900 mb-1">
          {broker?.name || 'Trading Platform'}
        </h1>
        <p className="text-slate-500 text-sm">Hoş geldiniz</p>
      </div>

      <div className="flex gap-2 mb-6">
        <button
          onClick={() => setIsLogin(true)}
          className={`flex-1 py-3 rounded-lg font-semibold transition-all ${
            isLogin
              ? 'text-white shadow-lg'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
          style={
            isLogin
              ? { background: 'linear-gradient(135deg, #7a0d10 0%, #4a0508 100%)' }
              : {}
          }
          data-testid="login-design6-tab-login"
        >
          Giriş Yap
        </button>
        <button
          onClick={() => setIsLogin(false)}
          className={`flex-1 py-3 rounded-lg font-semibold transition-all ${
            !isLogin
              ? 'text-white shadow-lg'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
          style={
            !isLogin
              ? { background: 'linear-gradient(135deg, #7a0d10 0%, #4a0508 100%)' }
              : {}
          }
          data-testid="login-design6-tab-register"
        >
          Kayıt Ol
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        {!isLogin && (
          <>
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">
                Ad Soyad
              </label>
              <input
                type="text"
                value={formData.full_name}
                onChange={(e) =>
                  setFormData({ ...formData, full_name: e.target.value })
                }
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-900 focus:border-transparent outline-none bg-white text-gray-900 placeholder-gray-400"
                placeholder="Adınız Soyadınız"
                data-testid="login-design6-input-fullname"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">
                TC Kimlik No
              </label>
              <input
                type="text"
                value={formData.tc_no}
                onChange={(e) =>
                  setFormData({ ...formData, tc_no: e.target.value })
                }
                required
                maxLength="11"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-900 focus:border-transparent outline-none bg-white text-gray-900 placeholder-gray-400"
                placeholder="11 haneli TC numaranız"
                data-testid="login-design6-input-tcno"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">
                Telefon
              </label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-900 focus:border-transparent outline-none bg-white text-gray-900 placeholder-gray-400"
                placeholder="5xxxxxxxxx"
                data-testid="login-design6-input-phone"
              />
            </div>
          </>
        )}

        <div>
          <label className="block text-sm font-medium mb-2 text-gray-700">
            Email
          </label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-900 focus:border-transparent outline-none bg-white text-gray-900 placeholder-gray-400"
            placeholder="email@example.com"
            data-testid="login-design6-input-email"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2 text-gray-700">
            Şifre
          </label>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              required
              className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-900 focus:border-transparent outline-none bg-white text-gray-900 placeholder-gray-400"
              placeholder="Şifreniz"
              data-testid="login-design6-input-password"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              data-testid="login-design6-toggle-password"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
        </div>

        {!isLogin && (
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Şifre Tekrar
            </label>
            <input
              type="password"
              value={formData.password_confirm}
              onChange={(e) =>
                setFormData({ ...formData, password_confirm: e.target.value })
              }
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-900 focus:border-transparent outline-none bg-white text-gray-900 placeholder-gray-400"
              placeholder="Şifrenizi tekrar girin"
              data-testid="login-design6-input-password-confirm"
            />
          </div>
        )}

        {error && (
          <div
            className="bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-lg text-sm"
            data-testid="login-design6-error"
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 text-white font-bold rounded-lg hover:opacity-90 disabled:opacity-50 transition-all"
          style={{
            background: 'linear-gradient(135deg, #7a0d10 0%, #4a0508 100%)',
          }}
          data-testid="login-design6-submit"
        >
          {loading ? 'Yükleniyor...' : isLogin ? 'Giriş Yap' : 'Kayıt Ol'}
        </button>
      </form>
    </div>
  </div>
);

export default Design6;
